import { useMemo } from 'react';
import { Theme, ThemeClassMap } from '../../schema/enum/themes';

export const useThemeClassMap = (theme: Theme): string | undefined => {
    return useMemo(() => {
        return ThemeClassMap.find(themeMap => themeMap.theme === theme)?.className;
    }, [theme]);
};